import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import { createStatistic } from 'store/app/actions';

export const submitConfirmedAuth = (authModel: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authConfirmed.isPosting) { return Promise.reject(); }

  dispatch({ type: types.POST_CONFIRMED_AUTH_REQUEST });

  return api.authorization.submitConfirmedAuth.post(authModel)
    .then((res: any) => {

      dispatch({
        type: types.POST_CONFIRMED_AUTH_SUCCESS,
        payload: res,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        0, 
        'AUTH SUCCESS', 
        sessionStorage.getItem('user_id')! 
      ));

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_CONFIRMED_AUTH_FAILURE,
        payload,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        1, 
        'AUTH FAILURE', 
        sessionStorage.getItem('user_id')! 
      ));

      return Promise.reject(payload);
    });
};
